document.addEventListener('DOMContentLoaded', () => {
  const toggles = document.querySelectorAll('.menu-toggle');
  const html = document.querySelector('html');
  const menu = document.querySelector('.menu');
  const header = document.querySelector('#header');
  const close_menu_logo = document.querySelector('#close-menu-logo');
  const open_menu_logo = document.querySelector('#open-menu-logo');
  const close_btn = document.querySelector('#close-btn');
  const open_btn = document.querySelector('#open-btn');
  const parent_menu_logo = document.querySelector('#parent-menu-logo');
  const overlay = document.querySelector('.menu-overlay');
  const profile_icon = document.querySelectorAll('.nav-icon');
  const policyContainer = document.querySelector(".shopify-policy__container");
  const main = document.querySelector("main")
  
  // Div Add
      if (policyContainer) {
      // New wrapper div create
      main.classList.add("legal-main")
      const wrapper = document.createElement("div");
       wrapper.classList.add("spacing-legal-page");
      wrapper.style.marginBottom = "5rem";
      policyContainer.parentNode.insertBefore(wrapper, policyContainer);
      wrapper.appendChild(policyContainer);
      }

  if (!toggles.length) return;

  toggles.forEach(toggle => {
    toggle.addEventListener('click', e => {
      e.preventDefault();

      if (!menu.classList.contains('active')) {
        // OPEN
        menu.classList.add('active');
        overlay.classList.add('active');
        html.classList.add('menu-active');
        open_menu_logo.style.setProperty("display", "flex");
        close_menu_logo.style.setProperty("display", "none");
        close_btn.style.setProperty("display", "flex", "important");
        open_btn.style.setProperty("display", "none", "important");
        header.style.setProperty("flex-direction", "row-reverse", "important");
        profile_icon.forEach(element => element.style.setProperty("display", "none", "important"));
       parent_menu_logo.classList.add('height-auto')
      } else {
        // CLOSE → allow animation → then hide
        menu.classList.remove('active');
        overlay.classList.remove('active');
        html.classList.remove('menu-active');
         close_menu_logo.style.setProperty("display", "flex");
        open_menu_logo.style.setProperty("display", "none");
         open_btn.style.setProperty("display", "flex", "important");
         close_btn.style.setProperty("display", "none", "important");
         header.style.setProperty("flex-direction", "row", "important");
         parent_menu_logo.classList.remove('height-auto')
         profile_icon.forEach(element => element.style.setProperty("display", "flex", "important"));
         
        // After transition ends → visibility hide (prevent overlap)
        setTimeout(() => {
          if (!menu.classList.contains('active')) {
            menu.style.visibility = "hidden";
            overlay.style.visibility = "hidden";
          }
        }, 800);
      }
    });
  });

  // Click outside also close
  overlay.addEventListener('click', () => {
    menu.classList.remove('active');
    overlay.classList.remove('active');
    html.classList.remove('menu-active');

    setTimeout(() => {
      if (!menu.classList.contains('active')) {
        menu.style.visibility = "hidden";
        overlay.style.visibility = "hidden";
      }
    }, 800);
  });

  // When opening → show immediately
  menu.addEventListener("transitionstart", () => {
    menu.style.visibility = "visible";
    overlay.style.visibility = "visible";
  });
});


    // Intersection Observer for Scroll Reveal
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.15
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add('active');
          }, entry.target.getAttribute("data-delay") ?? 0);
        }
      });
    }, observerOptions);
    // Observe all elements with reveal classes
    document.addEventListener('DOMContentLoaded', () => {
      const revealElements = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');
      revealElements.forEach(element => {
        observer.observe(element);
      });
    });


     document.addEventListener("DOMContentLoaded", function () {
    const logo = document.getElementById("parent-menu-logo");

    if (logo) {
      logo.style.cursor = "pointer";
      logo.addEventListener("click", function () {
        window.location.href = "/";
      });
    }
  });
